/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Общий вид для страницы товаров в претензии.
   */
  app.ClaimItemsCommonView = app.View.extend({
    el: '[data-jsview="claim-items"] .reducer #claim-edit',
    claimItemsJsonSelector: '#claim-items-json',
    events: {
      'click .add-claim-item': 'addClaimItem',
      'click .send-claim': 'sendClaim',
      'click .save-temp': 'saveClaim',
      'blur .claim-text': 'saveCommonComment'
    },
    run: function () {
      this.claim_id = this.$el.data('claim-id');
      this.model.reset(app.helpers.TemplateHelper.getJson(this.claimItemsJsonSelector));
      this.claimModel = new app.Claim({
        id: this.claim_id
      });
      this.itemViews = [];
      this.listenTo(this.model, 'remove', this.removeView);
      this.render();
    },
    render: function () {
      var that = this;
      _.each(this.model.models, function (num) {
        var element = that.$('[data-id=' + num.id + ']'),
          itemView;
        itemView = new app.ClaimItemView({
          cid: num.cid,
          model: num,
          el: element
        });
        that.itemViews.push(itemView);
        that.$el.find('#claim-items-content').append(itemView.render(element));
      });
      if (this.model.models.length === 0) {
        this.addClaimItem();
      }
      return this;
    },
    addClaimItem: function () {
      var itemView,
        model = new app.ClaimItem();
      this.model.add(model);
      model.set('claim_id', this.$el.data('claim-id'));
      itemView = new app.ClaimItemView({
        model: model,
        collection: this.model
      });
      this.itemViews.push(itemView);
      this.$el.find('#claim-items-content').append(itemView.render().el);
    },
    sendClaim: function () {
      var deferred = [];
      _.each(this.itemViews, function (view) {
        deferred.push(view.validateModel());
      });
      $.when.apply($, deferred).done(
        this.saveClaimModel({ claim_status_id: 2 })
      );
    },
    /**
     * Сохранение модели претензии
     * @param {Object} data Данные для сохранения
     */
    saveClaimModel: function (data) {
      if (data) {
        this.claimModel.save(data, {
          success: function () {
            if (data.claim_status_id === 2) {
              app.helpers.RedirectHelper.locationAssign('/claim/');
            } else {
              this.clearCommonCommentError();
            }
          }.bind(this),
          error: function (model, response) {
            var textError = _.find(response.responseJSON, {field: 'text'});
            if (textError) {
              this.setCommonCommentError(textError.message);
            } else {
              this.clearCommonCommentError();
            }
          }.bind(this)
        });
      }
    },
    saveClaim: function () {
      var deferred = [];
      _.each(this.itemViews, function (view) {
        deferred.push(view.validateModel());
      });
      $.when.apply($, deferred).done(function () {
        app.helpers.RedirectHelper.locationAssign('/claim/');
      });
    },
    /**
     * Сохранение комментария к претензии
     * @param {Event} event Событие оставления поля комментария притензии
     */
    saveCommonComment: function (event) {
      var text = $(event.target).val();
      this.saveClaimModel({ text: text });
    },
    /**
     * Установка ошибки для комментария притензии
     * @param {string} error Текст ошибки
     */
    setCommonCommentError: function (error) {
      if (error) {
        this.$('.claim-text').addClass('error');
        this.$('.claim-common-comment').text(error);
      }
    },
    /**
     * Очищение ошибки комментария к претензии
     */
    clearCommonCommentError: function () {
      this.$('.claim-text').removeClass('error');
      this.$('.claim-common-comment').text('');
    },

    removeView: function (model) {
      var that = this;
      _.each(this.itemViews, function (key, index) {
        if (key && key.model === model) {
          that.itemViews.splice(index, 1);
        }
      });
    }
  });
})();

}.call(window));